/**
@ngdoc controller
@name UpdateCreditDetailsCtrl

@description
This controller is used in Business Record - Credit Details.

*/
(function() {
    'use strict';
    var UpdateCreditDetailsCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel,xmsNotificationFactory) {
        console.log("Inside UpdateCreditDetailsCtrl");
        console.log("$scope"+$scope);
        console.log("$compile"+$compile);
        console.log("$uibModalInstance"+$uibModalInstance);
        console.log("ajaxCall"+ajaxCall);
        console.log("passedModel"+passedModel);
        $scope.ngModel = passedModel;
        $scope.creditDetailsModelForm = {}
        console.log("$scope.creditDetailsModel"+$scope.ngModel)
        $scope.closePop = function($event) {
            $uibModalInstance.close($scope.ngModel);
        }
        $scope.cancel = function() {
            $uibModalInstance.close($scope.ngModel);
        };
        $scope.fnUpdateCreditDetails = function($event) {

            $event.preventDefault();
            var ajaxUrl = WEBAPP_PATH + "/creditDetails/updateCreditDetails?";
            //var data    = $scope.ngModel + $scope.creditDetailsModelForm;
            var data = jQuery.param($scope.ngModel)+'&'+jQuery.param($scope.creditDetailsModelForm)

            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    $scope.ngModel.lastUpdated_d=$scope.creditDetailsModelForm.creditDetailsLastUpdated;
                    if (result.data.reload) {
                        $uibModalInstance.close($scope.ngModel);
                        location.reload();
                    }
                    else {
                        xmsNotificationFactory.addObj({id: "updateCreditDetails", type: "success", bodyHtml: 'Credit Details Updated Successfully', timeout:5});
                        $uibModalInstance.close($scope.ngModel);
                    }
                },
                function(result) {
                    var alertMessage = "Error occurred. Please try again later..";
                    xmsNotificationFactory.addObj({id: "updateCreditDetails", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $uibModalInstance.close($scope.ngModel);

                }
            );
            $event.preventDefault();
        }




    }
    UpdateCreditDetailsCtrl.$inject = ['$scope', '$compile', '$uibModalInstance', 'ajaxCall', 'params','xmsNotificationFactory'];
    angular.module('app').controller('UpdateCreditDetailsCtrl', UpdateCreditDetailsCtrl);
}());
